import {
  Box,
  Button,
  Flex,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Portal,
  useDisclosure,
  useOutsideClick,
} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useDesktop, useTranslation} from 'hooks';
import {ChevronDown, ChevronUp, Grid} from 'lucide-react';
import React, {FC, useRef} from 'react';

import MetroSidebar from '../../MetroSidebar';
import {IMetroCategory} from '../../types';
import MultiLevelDrawer from './MetroCategoryDrawer';

interface MetroCategoryMenuProps {
  categories: IMetroCategory[] | undefined;
  isLoading?: boolean;
}

const MetroCategoryMenu: FC<MetroCategoryMenuProps> = ({categories, isLoading = false}) => {
  const isDesktop = useDesktop();
  const {isOpen, onToggle, onClose} = useDisclosure();
  const buttonRef = useRef(null);
  const {t} = useTranslation();

  const handleClick = () => {
    onToggle();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onToggle();
    }
  };

  useOutsideClick({
    ref: buttonRef,
    handler: () => {
      if (isOpen) {
        onToggle();
      }
    },
  });

  if (!isDesktop) {
    return (
      <MultiLevelDrawer
        items={categories}
        isLoading={isLoading}
        title={t('PRODUCT_CATEGORIES')}
        triggerLabel="Categorii de produse"
      />
    );
  }

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom-start" closeOnBlur={true} closeOnEsc={true}>
      <PopoverTrigger>
        <Button
          ref={buttonRef}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          bg="#1e3a8a"
          color={colors.white}
          _hover={{bg: '#2c4db0'}}
          _active={{bg: '#1a307a'}}
          borderRadius="8px"
          p="12px 16px"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          aria-label="Categorii de produse"
          tabIndex={0}
        >
          <Flex alignItems="center">
            <Grid size={20} style={{marginRight: '8px'}} />
            <Box as="span" fontWeight="600" fontSize="16px">
              {t('PRODUCT_CATEGORIES')}
            </Box>
          </Flex>
          {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent
          width="auto"
          minWidth="280px"
          border="none"
          boxShadow="lg"
          p={0}
          borderRadius="16px"
          zIndex={1000}
        >
          <MetroSidebar categories={categories} isLoading={isLoading} />
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default MetroCategoryMenu;
